import { j as r } from "../../jsx-runtime-82a9ddf6.js";
/* empty css                    */import "../button/index.js";
import "../checkbox/index.js";
import "../spin/index.js";
import { Typography as n } from "../typography/index.js";
import "react";
import "../alert/index.js";
import "../../ReactCodeInput-cc430180.js";
import "../tooltip/index.js";
import { cn as e } from "../../lib/cn.js";
import "../dropdown/index.js";
/* empty css                    */import "../badge/index.js";
import "../switcher/index.js";
import "../toast/index.js";
import "../../react-toastify.esm-a636d9b1.js";
const T = ({
  wrapperStyle: o,
  value: t,
  label: p,
  name: s,
  className: a,
  ...i
}) => {
  const d = e("flex flex-row items-center gap-3", o), c = e(
    "form-radio",
    "w-[18px] h-[18px]",
    "border",
    "focus:ring-0 focus:ring-transparent focus:ring-offset-0 focus:ring-offset-transparent",
    "bg-white",
    "border-slate-200",
    "text-purple-600",
    "hover:border-purple-600 dark:hover:border-purple-500",
    "focus:border-purple-600 dark:focus:border-purple-500",
    "focus:checked:border-transparent dark:focus:checked:border-transparent",
    "disabled:bg-slate-50",
    "active:border-transparent checked:border-transparent",
    "checked:hover:bg-purple-400 dark:checked:hover:bg-purple-500",
    "disabled:border-slate-200 disabled:hover:border-slate-200",
    "dark:disabled:hover:border-slate-200",
    a
  );
  return /* @__PURE__ */ r.jsxs("div", { className: d, children: [
    /* @__PURE__ */ r.jsx(
      "input",
      {
        className: c,
        type: "radio",
        name: s,
        value: t,
        ...i
      }
    ),
    /* @__PURE__ */ r.jsx(n, { children: p })
  ] });
};
export {
  T as Radio
};
